'use strict';
define([
    'angular',
    'modules/settings/logs/logs.controller'
], function (angular, LogsController) {
    var app = angular.module('settings.logs', []);
    app.controller('LogsController', LogsController);
    return app;
});
